import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../store";
import { fetchMspInformation } from "../features/msp/services/mspService";
import { setError } from "../features/msp/slices/apiStatusSlice";
import type { MSPInformation } from "../features/common/types";

export const useMSPData = (mspId: number) => {
  const dispatch = useDispatch<AppDispatch>();
  const [msp, setMsp] = useState<MSPInformation | null>(null);

  const fetchData = useCallback(async () => {
    if (!mspId || mspId <= 0) return;
    try {
      const resp = await fetchMspInformation(mspId);
      setMsp(resp?.data ?? null);
    } catch (error) {
      console.error("Failed to fetch MSP data", { mspId, error });
      dispatch(setError("Failed to fetch MSP data"));
      throw error;
    }
  }, [dispatch, mspId]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  return { msp, fetchData } as const;
};
